<div class="container register mt-5 mb-5">
  <div class="row">
    <div class="col-md-4 col-sm-12">
    </div>
    <div class="col-md-4 col-sm-12">
      <div class="text-center">
        <img src="assets/images/logo_white.png" class="img-fluid" style="max-width: 250px;" alt="Logo bededadev.cl" />
      </div>
      <form novalidate [formGroup]="loginForm" (ngSubmit)="login()">
        <h2 class="text-center">General Security</h2>
        <p class="text-muted text-center">
          Sistema de control de ingreso
        </p>
        <div class="input-group mb-3">
          <span class="input-group-text"><i class="fa fa-user"></i></span>
          <input type="text" formControlName="rut" class="form-control" (keyup)="onFormatRut($event)" autocomplete="off"
            placeholder="Usuario" />
        </div>
        <div class="input-group mb-4">
          <span class="input-group-text"><i class="fa fa-lock"></i></span>
          <input type="password" formControlName="pass" class="form-control" placeholder="Contraseña" />
        </div>

        <div class="row">
          <div class="col-md-12 mb-2">
            <div class="g-recaptcha"></div>
          </div>
          <div class="col-md-12">
            <button type="submit" class="btn btn-primary px-4 w-100">
              ACCEDER
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-md-4 col-sm-12">

    </div>
  </div>
</div>